import { useClickOutside } from '@src/Common/Hooks/useClickOutside';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { ArrowDown, ArrowUp } from '../DropdownGeneral/DropdownGeneral';
import styles from './DropdownYear.module.scss';
import { DropdownYearProps } from './DropdownYear.type';

const RightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_755_10542"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_755_10542)">
      <path
        d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);
const LeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_755_10512"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_755_10512)">
      <path
        d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);
const DropdownYear: React.FC<DropdownYearProps> = ({
  defaultValue,
  list,
  onChange,
  canResetYear: hasReset = false,
  disabled = false
}) => {
  const [chosenYear, setChosenYear] = useState<number | undefined>(undefined);
  const [selectedYear, setSelectedYear] = useState<number | null>(
    defaultValue ?? null
  );
  const [open, setOpen] = useState<boolean>(false);

  const onReset = () => {
    setChosenYear(undefined);
  };

  const onCancel = () => {
    setOpen((s) => !s);
    setChosenYear(undefined);
  };
  const onApply = () => {
    if (chosenYear) {
      setSelectedYear(chosenYear);
    } else {
      setSelectedYear(null);
    }
    if (onChange) {
      onChange(chosenYear);
    }
    setOpen((s) => !s);
  };

  const domNode = useClickOutside(() => {
    setOpen(false);
  });
  useEffect(() => {
    if (defaultValue) {
      setSelectedYear(defaultValue);
      setChosenYear(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const onRightArrow = () => {
    const indexOfCurrentYear = list.findIndex((year) => chosenYear === year);
    if (indexOfCurrentYear > -1) {
      setChosenYear(list[indexOfCurrentYear + 1]);
    } else {
      // select first year
      setChosenYear(list[0]);
    }
  };
  const onLeftArrow = () => {
    const indexOfCurrentYear = list.findIndex((year) => chosenYear === year);
    if (indexOfCurrentYear > -1 && indexOfCurrentYear < list.length - 1) {
      setChosenYear(list[indexOfCurrentYear - 1]);
    } else {
      // select last year
      setChosenYear(list[list.length - 1]);
    }
  };

  return (
    <div
      data-testid="dropdown-year"
      className={styles['area']}
      id="area"
      ref={domNode}
    >
      <div
        className={
          styles['ContainerDate'] + ' ' + (disabled ? styles['Disabled'] : '')
        }
        onClick={() => (!disabled ? setOpen((s) => !s) : null)}
      >
        <h1>{selectedYear ?? 'All Year'}</h1>
        {!open ? <ArrowDown /> : <ArrowUp />}
      </div>
      {open ? (
        <div className={styles['Dialog']}>
          <div className={styles['Header']}>
            <Button onClick={onLeftArrow}>
              <LeftIcon />
            </Button>
            <h1>Select Year</h1>
            <Button onClick={onRightArrow}>
              <RightIcon />
            </Button>
          </div>
          <div className={styles['Content']}>
            {list.map((year) => (
              <Button
                className={chosenYear === year ? styles['Selected'] : ''}
                onClick={() => {
                  if (hasReset && chosenYear && year === chosenYear) {
                    onReset();
                    return;
                  }
                  setChosenYear(year);
                }}
                key={year}
              >
                {year}
              </Button>
            ))}
          </div>
          <div className={styles['Footer']}>
            <Button onClick={onCancel} className={styles['BtnCancel']}>
              Cancel
            </Button>
            <Button onClick={onApply} className={styles['BtnApply']}>
              Apply
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DropdownYear;
